import React, { useRef, useEffect, useState } from 'react';
import { Card, Avatar, Button, Badge, Space, message, Input, List, Tag , Typography, Spin,Popconfirm } from 'antd';
import { LikeOutlined, MessageOutlined, CalendarOutlined, LeftOutlined, SendOutlined, UserOutlined,DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import { API_BASE_URL } from '../config';
import { size } from 'lodash';
const { TextArea } = Input;
const { Title } = Typography;
const PostDetail = ({ post, currentUser, onLike, onBack,onRefresh, scrollToComments }) => {
  const [commentText, setCommentText] = useState('');
  const [showComments, setShowComments] = useState(true);
  const commentsRef = useRef(null);
  const [itemData, setItemData] = useState(null);

  const fetchItemData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/database/more_information`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            vp_id: post.vp_id
          })
        });
        const data = await response.json();
        if (data) {
          setItemData(data);
          console.log("每个贴子的其它信息：",data);
        } else {
          message.error(data.message || '获取数据失败');
        }
      } catch (error) {
        message.error('请求失败');
        console.error('Error:', error);
      }
    };

  const onAddComment = async (postId, commentContent) => {
    const response = await fetch(`${API_BASE_URL}/posts/insert_comments`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            vc_content: commentContent,
            vc_du_id: currentUser.userId,
            vc_vp_id: postId

          })
        });
    console.log("添加评论");
    fetchItemData();
  };
  useEffect(() => {
    if(post?.vp_id)
    fetchItemData();
  }, [post]);

  // 监听滚动到评论区域的触发
  useEffect(() => {
    if (scrollToComments && commentsRef.current) {
      setTimeout(() => {
        commentsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [scrollToComments]);

  // Convert post content to Delta format for Quill
  const contentToDelta = (content) => {
    if (!content) return { ops: [{ insert: '\n' }] };
    return {
      ops: [
        { insert: content },
        { insert: '\n' }
      ]
    };
  };

  if (!post) {
    return (
      <div style={{ textAlign: 'center', padding: '50px 0' }}>
        <p>帖子不存在</p>
        <Button onClick={onBack}>返回列表</Button>
      </div>
    );
  }
  if (!itemData) {
    return (
      <Card style={{ marginBottom: '16px' }}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="small" />
          <span style={{ marginLeft: '8px' }}>加载中...</span>
        </div>
      </Card>
    );
  }

  return (
    <div>
      <Button 
        icon={<LeftOutlined />} 
        onClick={onBack}
        style={{ marginBottom: '16px' }}
      >
        返回列表
      </Button>
      
      <Card 
        hoverable 
        actions={[
          <Button 
            icon={<LikeOutlined />} 
            onClick={() => onLike(post.vp_id)}
            type={itemData.likes.some(like => like.userid === currentUser?.userId) ? "primary" : "text"}
          >
            {itemData.likes.length}
          </Button>,
          <Button 
            icon={<MessageOutlined />} 
            type="text"
            onClick={() => setShowComments(!showComments)}
          >
            {size(itemData.comments)}
          </Button>
        ]}
      >
        {/* 显示选中的用户 */}
          {itemData.selectedUsers && size(itemData.selectedUsers) > 0 && (
            <div style={{ marginTop: '16px' }}>
              <Space wrap>
                <div style={{ fontSize: '16px', color: '#FFD700', marginBottom: '8px' }}>value之星：</div>
                {itemData.selectedUsers.map((user, index) => (
                  <Space key={index} align="center" style={{ marginRight: '12px' }}>
                    <Avatar 
                      size="large" 
                      src={user.avatar} 
                      icon={<UserOutlined />}
                      alt={user.name}
                    />
                    <span style={{ fontSize: '13px' }}>{user.name}</span>
                    {user.title && (
                      <span style={{ fontSize: '12px', color: '#999' }}>({user.title})</span>
                    )}
                  </Space>
                ))}
              </Space>
            </div>
          )}
        {/* 显示选中的价值观 */}
          {post.vp_value && (
            <div style={{ marginTop: '16px' }}>
              <Space wrap>
                {JSON.parse(post.vp_value).map((value, index) => (
                  <Tag key={index} color="blue">{value}</Tag>
                ))}
              </Space>
            </div>
          )}
        <Card.Meta
          description={
            <span>
              <CalendarOutlined style={{ fontSize: '12px', marginRight: '4px' ,marginTop:'12px'}} />
              {moment(post.vp_datetime).format('YYYY-MM-DD HH:mm')}
            </span>
          }
        />
        <div style={{ marginTop: '20px', maxWidth: '100%' }}>
          {post.vp_title && (
            <Title level={2}>{post.vp_title}</Title>
          )}
          <div 
            className="post-content"
            dangerouslySetInnerHTML={{ __html: post.vp_content }} 
          />
        </div>
        <style>
          {`
            .post-content img {
              max-width: 100% !important;
              height: auto !important;
              object-fit: contain !important;
            }
          `}
        </style>
        <Space style={{ marginRight: '12px' }}>
          发帖人：
          <Avatar 
            size="large" 
            src={post.avatar} 
            icon={<UserOutlined />}
            alt={post.name}
          />
          <span style={{ fontSize: '13px' }}>{post.name}</span>
        </Space>
        {size(itemData.likes) > 0 && (
          <div style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
            <span>点赞的人：</span>
            {itemData.likes.map(like => (
              <>
                <Avatar 
                  key={like.userId} 
                  src={like.avatar} 
                  alt={like.name}
                  size="small"
                  style={{ marginLeft: '4px' }}
                />
                <span>{like.name}</span>
              </>
            ))}
          </div>
        )}
        
        {/* 评论区域 */}
        {showComments && (
          <div ref={commentsRef} style={{ marginTop: '20px', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
            {/* 评论输入框 */}
            <div style={{ marginBottom: '16px', display: 'flex', gap: '8px' }}>
              <TextArea
                placeholder="写下你的评论..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                autoSize={{ minRows: 2, maxRows: 4 }}
                style={{ flex: 1 }}
              />
              <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={() => {
                  const trimmedComment = commentText.trim();
                  if (trimmedComment) {
                    onAddComment(post.vp_id, trimmedComment);
                    setCommentText('');
                  } else {
                    message.warning('评论内容不能为空');
                  }
                }}
                disabled={!commentText.trim()}
              >
                发送
              </Button>
            </div>
            
            {/* 评论列表 */}
            {size(itemData.comments) > 0 ? (
              <List
                itemLayout="horizontal"
                dataSource={itemData.comments}
                renderItem={comment => (
                  <List.Item
                  actions={[
                  <Popconfirm
                    title="确定要删除这条内容吗？"
                    onConfirm={async () => {
                        const response = await fetch(`${API_BASE_URL}/posts/delete_comments`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          vc_userid: comment.userid,
                          vc_vp_id:post.vp_id
                        })
                      });
                      const result = await response.json();
                      console.log("删除评论结果:", result);
                      if (result) {
                        message.success('删除成功');
                        // 重新获取帖子信息
                        if (onRefresh) {
                          onRefresh();
                        }
                      }
                    }}
                    okText="确定"
                    cancelText="取消"
                  >
                    {comment.userid === currentUser?.userId ? (
                      <span style={{ cursor: 'pointer', color: '#ff4d4f' }}>
                        <DeleteOutlined /> 删除
                      </span>
                    ) : null}
                  </Popconfirm>
                ]}
                  >
                    <List.Item.Meta
                      avatar={<Avatar src={comment.avatar} alt={comment.name} />}
                      title={
                        <Space>
                          <span>{comment.name}</span>
                          {comment.userid === currentUser?.userId && (
                            <Badge status="processing" text="我" />
                          )}
                        </Space>
                      }
                      description={
                        <div>
                          <div style={{ marginBottom: '4px' }}>{comment.content}</div>
                          <span style={{ fontSize: '12px', color: '#999' }}>
                            {moment(comment.datetime).format('YYYY-MM-DD HH:mm')}
                          </span>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            ) : (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px 0' }}>
                暂无评论，快来发表第一条评论吧！
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
};
export default PostDetail;